export const getNavigationTitle = ({ isUnitPDP, unitPDPTitle, isClothingOrAccessoriesPDP, clothingOrAccessoriesPDPTitle, title, }) => {
    if (isUnitPDP) {
        return unitPDPTitle || '';
    }
    if (isClothingOrAccessoriesPDP) {
        return clothingOrAccessoriesPDPTitle || '';
    }
    return title;
};
